import { Grid } from '../Grid';
import { TileImageSkeleton } from '../Tile/TileImageSkeleton';

export interface SkeletonImageLoadingProps {
  cols?: number;
  rows?: number;
  bgColor?: string;
  large?: boolean;
  small?: boolean;
}

interface ArrList {
  [key: string]: number;
}

export const SkeletonImageLoading = ({
  cols = 5,
  rows = 3,
  bgColor = 'bg-ds-natural-50',
  large,
  small,
}: SkeletonImageLoadingProps) => {
  const arr: ArrList[] = [];
  for (let i = 0; i < cols * rows; i++) {
    arr.push({ id: i });
  }
  return (
    <div>
      {large ? (
        <Grid
          cols={cols}
          data={arr}
          renderItem={() => <TileImageSkeleton large />}
        />
      ) : small ? (
        <Grid
          cols={cols}
          data={arr}
          renderItem={() => (
            <TileImageSkeleton
              small
              bgColor={bgColor}
            />
          )}
        />
      ) : (
        <Grid
          cols={cols}
          data={arr}
          renderItem={() => <TileImageSkeleton bgColor={bgColor} />}
        />
      )}
    </div>
  );
};
